import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import Parcours from "../../component/map/parcours.js";
import moment from 'moment';

import 'moment/locale/fr';
moment.locale('fr');

class Parcourscon extends React.Component{
  constructor(props) {
        super(props);

        this.onChangeDateRange = this.onChangeDateRange.bind(this)
        this.onChangeCenter = this.onChangeCenter.bind(this)
        this.handleMarkerClick = this.handleMarkerClick.bind(this)
        this.handleCenterChanged = this.handleCenterChanged.bind(this)
        this.handleZoomChanged = this.handleZoomChanged.bind(this)
        this.onChangeDirections = this.onChangeDirections.bind(this)
        this.onSeeMore = this.onSeeMore.bind(this)
        this.handleAddressChange = this.handleAddressChange.bind(this)
        this.editAudit = this.editAudit.bind(this)
        this.handleChangeTravelMode = this.handleChangeTravelMode.bind(this)
        this.searchDirection = this.searchDirection.bind(this)

        this.state = {
            travelMode: "Driving",
            submitted: false,
            lat: 46.22475,
            lng: 2.0517,
            zoom: 6,
            dialogIsOpen: false,
            dateStart: (new Date()).setMonth((new Date()).getMonth()),
            dateEnd: (new Date()).setMonth((new Date()).getMonth()+1),
            audit_selected: null,
            directions: null,
            directions2: null,
            seeMore: null,
            from: {
                address: "",
                longitude: null,
                latitude: null,
            },
            to: {
                address: "",
                longitude: null,
                latitude: null,
            },
            optimized_waypoint_order: null,
        }

      this.mapParcours = React.createRef();
  }

    componentWillMount() {
        /* import les audits */
        this.props.getAuditsAction()
    }

    onSeeMore(audit_id) {
        var audit = this.props.audits.find(audit => audit.id === audit_id);
        if(audit){
            this.setState({seeMore: audit, lat: audit.latitude, lng: audit.longitude, zoom: 16, audit_selected: audit.id},() => {
                this.mergeStateAndFormdata(audit);
            })
        }else{
            this.setState({seeMore: null})
        }
    }

    onChangeDateRange(dateStart, dateEnd) {
        this.setState({dateStart, dateEnd})
    }

    onChangeCenter(lat, lng, zoom){
        this.setState({lat: lat, lng: lng, zoom: zoom})
    }

    handleMarkerClick = (audit, disableSeeMore) => {
      if(!disableSeeMore){
          this.setState({seeMore: audit, lat: audit.latitude, lng: audit.longitude, zoom: 16, audit_selected: audit.id},() => {
              this.mergeStateAndFormdata(audit);
          })
      }else{
          this.setState({lat: audit.latitude, lng: audit.longitude, zoom: 16, audit_selected: audit.id})
      }
    }

    searchDirection(audits){
        if(this.state.from && this.state.from.address !== "" && this.state.to && this.state.to.address !== "" && audits && audits.length > 0){
            const DirectionsService = new window.google.maps.DirectionsService();
            var waypoints = audits.map((audit, index)=>{
                return { location: new window.google.maps.LatLng(audit.latitude, audit.longitude) }
            });

            var travelmode = window.google.maps.TravelMode.DRIVING;
            switch(this.state.travelMode){
                case "Walking":
                    travelmode = window.google.maps.TravelMode.WALKING
                    break;
                case "Bicycling":
                    travelmode = window.google.maps.TravelMode.BICYCLING
                    break;
                case "Transit":
                    travelmode = window.google.maps.TravelMode.TRANSIT
                    break;
                default :
                    travelmode = window.google.maps.TravelMode.DRIVING
                    break;
            }

            DirectionsService.route({
                origin: new window.google.maps.LatLng(this.state.from.latitude, this.state.from.longitude),
                destination: new window.google.maps.LatLng(this.state.to.latitude, this.state.to.longitude),
                waypoints: waypoints,
                travelMode: travelmode,
                provideRouteAlternatives: false,
                optimizeWaypoints: false,
            }, (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {

                    this.onChangeDirections(result, null)
                    /*DirectionsService.route({
                        origin: new window.google.maps.LatLng(this.state.from.latitude, this.state.from.longitude),
                        destination: new window.google.maps.LatLng(this.state.to.latitude, this.state.to.longitude),
                        waypoints: waypoints,
                        travelMode: window.google.maps.TravelMode.DRIVING,
                        provideRouteAlternatives: false,
                        optimizeWaypoints: true,
                    }, (result2, status) => {
                        if (status === window.google.maps.DirectionsStatus.OK) {
                            this.state.onChangeDirections(result, result2, )
                        } else {
                            console.error(`error fetching directions ${result2}`);
                        }
                    });*/

                } else {
                    //console.error(`error fetching directions ${result}`);
                    //console.log(result)
                }
            });
        }
    }

    /* Merge les données de l'audit avec celle du formulaire afin de le pré-remplir */
    mergeStateAndFormdata(audit) {
        let seeMore = Object.assign({}, this.state.seeMore);
        seeMore.date = (audit.date) ? audit.date : "";
        seeMore.dateLimit = (audit.date_limit) ? audit.date_limit : "";
        delete seeMore.date_limit;
        seeMore.address = (audit.address) ? audit.address : "";
        seeMore.longitude = (audit.longitude) ? audit.longitude : "";
        seeMore.latitude = (audit.latitude) ? audit.latitude : "";
        seeMore.lot = (audit.lot) ? audit.lot : "";
        seeMore.client = (audit.client) ? audit.client : "";
        seeMore.status = (audit.status) ? audit.status : "";
        seeMore.preview = (audit.preview) ? {path: audit.preview.path, title: audit.preview.title} : {};
        seeMore.company.name = (audit.company.name) ? audit.company.name : "";
        seeMore.company.reference = (audit.company.reference) ? audit.company.reference : "";
        this.setState({seeMore: seeMore});
    }

    handleCenterChanged(){
        const center = this.mapParcours.current.getCenter();
        if (center.lat() !== this.state.lat && center.lng() !== this.state.lng) {
            this.setState({lat: center.lat(), lng: center.lng()});
        }
    }

    handleZoomChanged(){
        const zoomLevel = this.mapParcours.current.getZoom();
        if (zoomLevel !== this.state.zoom) {
            this.setState({zoom: zoomLevel});
        }
    }

    onChangeDirections(directions, directions2){
        this.setState({directions: directions, directions2: directions2, optimized_waypoint_order: directions2 ? directions2.routes[0].waypoint_order : null});
    }

    handleAddressChange(event, target){
        if(event.target.name === "address"){
            let fromto = Object.assign({}, this.state[target]);
            fromto["address"] = event.target.value;
            this.setState({[target]: fromto});
        }else if(event.target.name === "longitude"){
            let fromto = Object.assign({}, this.state[target]);
            fromto["longitude"] = event.target.value;
            this.setState({[target]: fromto});
        }else if(event.target.name === "latitude"){
            let fromto = Object.assign({}, this.state[target]);
            fromto["latitude"] = event.target.value;
            this.setState({[target]: fromto});
        }
    }

    handleChangeTravelMode = event => {
        this.setState({ travelMode: event.target.value });
    };

    handleFormSubmit(){
        //
    }

    editAudit(date){
        var _this = this;
        let seeMore = Object.assign({}, this.state.seeMore);
        seeMore["date"] = date.format();
        this.setState({ submitted: true, seeMore: seeMore }, () => {
            var audit = Object.assign({}, this.state.seeMore);
            delete audit.id;
            delete audit.created;
            delete audit.updated;
            delete audit.invoices;
            delete audit.report;
            delete audit.company.id;
            delete audit.company.audits;
            this.props.updateAuditAction(this.state.seeMore.id, audit).then(res => {
                /* Charge les events de l'agenda google */
                _this.props.getAuditsCalendarEventsAction().then(res => {
                    //console.log(res);
                    _this.setState({
                        submitted: false
                    })
                }).catch(err=> {
                    //console.log(err);
                    _this.setState({
                        submitted: false
                    })
                })
            }).catch(err => {
                this.setState({
                    submitted: false
                })
            })
        })
    }

  render(){
    return <Parcours
        mapParcours={this.mapParcours}
        dateStart={this.state.dateStart}
        dateEnd={this.state.dateEnd}
        lat={this.state.lat}
        lng={this.state.lng}
        zoom={this.state.zoom}
        audit_selected={this.state.audit_selected}
        audits={(!this.state.dateStart || !this.state.dateEnd) ? this.props.audits : this.props.audits.sort(function(a,b){
            return moment(a.date) - moment(b.date);
        }).filter(audit => (moment(audit.date).isSameOrAfter(this.state.dateStart) && moment(audit.date).isSameOrBefore(this.state.dateEnd)))}
        onChangeDateRange={this.onChangeDateRange}
        onChangeCenter={this.onChangeCenter}
        handleMarkerClick={this.handleMarkerClick}
        handleCenterChanged={this.handleCenterChanged}
        handleZoomChanged={this.handleZoomChanged}
        handleChangeTravelMode={this.handleChangeTravelMode}
        directions={this.state.directions}
        directions2={this.state.directions2}
        onChangeDirections={this.onChangeDirections}
        onSeeMore={this.onSeeMore}
        seeMore={this.state.seeMore}
        from={this.state.from}
        to={this.state.to}
        optimized_waypoint_order={this.state.optimized_waypoint_order}
        handleAddressChange={this.handleAddressChange}
        handleFormSubmit={this.handleFormSubmit}
        editAudit={this.editAudit}
        user={this.props.user}
        travelMode={this.state.travelMode}
        searchDirection={this.searchDirection}
    ></Parcours>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Parcourscon);



// WEBPACK FOOTER //
// ./src/container/map/parcours-container.js